import type { ValueOf } from '#layers/base/public';
import type {
	GlobalFieldId,
} from './schema/ids';

export const DisplayTemplateAstType = {
	Doc: 'doc',
	Text: 'text',
	Ref: 'ref',
} as const;

export type DisplayTemplateAstType = ValueOf<typeof DisplayTemplateAstType>;

interface AstNode<Type extends DisplayTemplateAstType = DisplayTemplateAstType> {
	type: Type;
}

interface ContentNode<Type extends DisplayTemplateAstType = DisplayTemplateAstType, Child extends AstNode = never> extends AstNode<Type> {
	content?: Child[];
}

export type TextNode = AstNode<typeof DisplayTemplateAstType.Text> & { text: string };
export type RefNode = AstNode<typeof DisplayTemplateAstType.Ref> & { attrs: { fieldId: GlobalFieldId | GlobalFieldId[] } };

export type DisplayTemplateAst = ContentNode<typeof DisplayTemplateAstType.Doc, TextNode | RefNode>;
export type DisplayTemplate = string | DisplayTemplateAst;
